import * as React from 'react';
import { Avatar, Typography, PreLoader } from '@/elements';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { AutoSizer } from 'react-virtualized';
import { ReactProgressiveList } from '@/components';
import isEmpty from 'lodash/isEmpty';

import './index.scss';
import * as actions from '@/redux/new_store_structure/actions';
import { withClientId } from '@/hocs';
import { getHolder } from '@/redux/modules/model/holder';
import moment from 'moment';
import { Empty } from 'antd';
import HolderDrawer from '@/pages/live-view/components/holder-drawer';
import LiveViewHeader from '@/pages/live-view/components/header';

const { Text } = Typography;

//helper
export const timeFormat = 'HH:mm:ss';

const arrayToObject = (arr, keyField) =>
	Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

const arrayToObjectChunked = (arr, keyField, chunkSize = 10000) => {
	const result = {};
	for (let i = 0; i < arr.length; i += chunkSize) {
		const chunk = arr.slice(i, i + chunkSize);
		Object.assign(result, ...chunk.map(item => ({ [item[keyField]]: item })));
	}
	return result;
};

const getVal = (holder, key) => holder && holder[key];
const getValWithDefault = (holder, key, val) => (holder && holder[key]) || val;

class GridCards extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			columnCount: 5,
			rowCount: 10,
			columnWidth: 198,
			holdersList: [],
			visible: false,
			loading: false,
			holderListReady: false,
			currentHolder: {},
		};
	}

	componentDidMount() {
		const { clientId } = this.props;
		const activeFilter = { active: true }
		this.props.getHoldersList({ clientId, filter: activeFilter });
		setTimeout(() => this.setState({ holderListReady: true }), 5000);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.list !== this.props.list && this.props.list.length > 0) {
			this.calculateColRowCount();
		}
		if (
			prevProps.holdersList !== this.props.holdersList &&
			this.props.holdersList.length > 0
		) {
			this.setState({
				holdersList: arrayToObjectChunked(
					this.props.holdersList,
					'clientReference',
				),
			});
		}
	}

	// calculation

	getDatum(index) {
		const { list } = this.props;
		return list[index];
	}

	calculateColRowCount = () => {
		const { list } = this.props;
		const { columnCount } = this.state;
		this.setState({
			columnWidth: Math.floor(this.width / columnCount),
			rowCount: Math.ceil(list.length / columnCount),
			holderListReady: true,
		});
	};

	onResize = ({ width }) => {
		const { columnCount } = this.state;
		this.width = width;
		this.calculateColRowCount();
		this.isLessXS = width < 450;
		if (this.isLessXS) {
			if (columnCount > 3) {
				this.setColumn(1);
			}
		} else {
			if (columnCount === 1) {
				this.setColumn(3);
			}
		}
	};

	// handlers
	setColumn = val => {
		this.setState({ columnCount: val }, this.calculateColRowCount);
	};
	incColumn = () => {
		this.setState(
			({ columnCount }) => ({ columnCount: columnCount + 1 }),
			this.calculateColRowCount,
		);
	};
	decColumn = () => {
		this.setState(
			({ columnCount }) => ({ columnCount: columnCount - 1 }),
			this.calculateColRowCount,
		);
	};

	handleModalOpen = ({
		clientReference,
		detectionTime,
		zoneId,
		siteId,
		thermalAlert,
	}) => {
		const getZoneName = () => {
			const res = this.props.zonesList.find(el => el.zoneId === zoneId);
			if (res) {
				return res.name;
			}
		};
		var zoneName = getZoneName();
		if (zoneName) {
		} else {
			zoneName = zoneId
		}
		const siteName = this.props.sitesList.find(el => el.siteId === siteId)
			.description;
		const { clientId, getHolder, getVisitsList } = this.props;
		this.setState({ currentHolder: {}, loading: true, visible: true });
		if (clientReference) {
			getHolder({ clientId, clientReference }).then(res => {
				this.setState({
					currentHolder: {
						...res.payload,
						detectionTime,
						zoneName,
						siteName,
						thermalAlert,
					},
					loading: false,
				});
			});
			getVisitsList({ clientId, clientReference });
		} else {
			this.setState({
				currentHolder: {
					name: 'Guest/Unidentified',
					detectionTime,
					zoneName,
					siteName,
					thermalAlert,
				},
				loading: false,
			});
		}
	};

	handleDrawerClose = () => {
		this.setState({ visible: false });
	};

	// render

	cellRenderer = index => {
		const { columnCount, holdersList } = this.state;
		const { clientId, getHolder } = this.props;
		let rowData = [];
		for (let columnIndex = 0; columnIndex < columnCount; columnIndex++) {
			const dataInd = index * columnCount + columnIndex;
			const datum = this.getDatum(dataInd);
			const holder = datum && holdersList[datum.clientReference];
			if (
				clientId &&
				datum &&
				datum.clientReference &&
				!isEmpty(holdersList) &&
				!holdersList.hasOwnProperty(datum.clientReference)
			) {
				// getHolder if does not it holdersList
				getHolder({
					clientId,
					clientReference: datum.clientReference,
				}).then(res => {
					res &&
						res.payload &&
						this.setState(state => ({
							holdersList: {
								...state.holdersList,
								[res.payload.clientReference]: {
									...res.payload,
								},
							},
						}));
				});
			}
			rowData.push({ datum, holder });
		}
		return (
			<div key={index} className={'grid-row-wrap'}>
				<div className={'cardTween'}>
					{rowData.map((item, i) => {
						const className = [
							'holder-card_wrap',
							item.datum && item.datum.thermalAlert
								? 'blinking_warning'
								: item.datum && item.datum.birthday
								? 'birthday_warning'
								: item.datum && item.datum.expiredMember
								? 'expiredMember_warning'
								: item.datum && item.datum.newMember
								? 'newMember_warning'
								: item.datum && item.datum.topSpender
								? 'topSpender_warning'
								: undefined,
						].join(' ');
						return item.datum ? (
							<div
								key={i}
								className={className}
								style={{
									maxWidth: `${this.width / columnCount -
										10}px`,
								}}
								onClick={() => this.handleModalOpen(item.datum)}
							>
								<Avatar
									image={getVal(item.holder, 'imagePath')}
								/>
								{clientId === "groucho" && <div className="holder-card_title_wrap">
									<Text ellipsis style={{ color: '#ffffff' }}>
										{getValWithDefault(
											item.holder,
											'name',
											'Guest/Unidentified',
										)}
									</Text>
								</div>}
								<div className="holder-card_text_wrap">
									{clientId !== "groucho" && <Text ellipsis style={{ color: '#00a7c0' }}>
										{getValWithDefault(
											item.holder,
											'name',
											'Guest/Unidentified',
										)}
									</Text> }
									<Text ellipsis>
										ID: {item.datum.clientReference || '-'}
									</Text>
									<Text ellipsis>
										{moment(
											item.datum.detectionTime,
										).format(timeFormat)}{' '}
										<span style={{ fontSize: '0.7em' }}>
											{!moment(
												item.datum.detectionTime,
											).isSame(moment(), 'day') &&
												'Yesterday'}
										</span>
									</Text>
									<Text ellipsis>
										{item.datum.siteId}
									</Text>
									<Text ellipsis>
										{item.datum.zoneId}
									</Text>
									<Text ellipsis>
										{item.datum.source}
									</Text>
								</div>
							</div>
						) : null;
					})}
				</div>
			</div>
		);
	};

	render() {
		const {
			columnCount,
			rowCount,
			visible,
			loading,
			currentHolder,
			holdersList,
			holderListReady,
		} = this.state;
		const {
			list,
			loadingList,
			clientDetail,
			visitsList,
			loadingVisits,
			sitesList,
			clientId,
			zonesList,
		} = this.props;
		return (
			<React.Fragment>
				<LiveViewHeader
					columnCount={columnCount}
					count={list && list.length}
					isLessXS={this.isLessXS}
					incColumn={this.incColumn}
					decColumn={this.decColumn}
				/>
				<div className="list-wrap">
					{!isEmpty(holdersList) && list && list.length > 0 ? (
						<AutoSizer onResize={this.onResize} disableHeight>
							{({ width }) => {
								this.width = width;
								return (
									<ReactProgressiveList
										width={width}
										initialAmount={6}
										progressiveAmount={6}
										renderItem={this.cellRenderer}
										renderLoader={() => (
											<div>
												<PreLoader />
											</div>
										)}
										rowCount={rowCount}
										useWindowScroll
									/>
								);
							}}
						</AutoSizer>
					) : (
						<div className="no-holders">
							{holderListReady && !loadingList ? (
								<Empty
									description={
										'Hello, it doesn’t look like anyone has been seen here recently. Try selecting a different zone or site or changing the search.'
									}
								/>
							) : (
								<PreLoader />
							)}
						</div>
					)}
				</div>
				<HolderDrawer
					loading={loading || loadingVisits}
					visits={visitsList}
					currentHolder={currentHolder}
					clientDetail={clientDetail}
					visible={visible}
					sitesList={sitesList}
					clientId={clientId}
					showZone={zonesList.length >= 1}
					handleDrawerClose={this.handleDrawerClose}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ({ holders, sites, model, visits }) => ({
	holdersList: holders.list,
	loadingList: holders.loading,
	zonesList: sites.zonesList,
	sitesList: sites.list,
	clientDetail: model.clientDetail,
	visitsList: visits.list,
	loadingVisits: visits.loading,
});

const mapDispatchToProps = dispatch => ({
	getHoldersList: params => dispatch(actions.getHoldersList(params)),
	getVisitsList: params => dispatch(actions.getVisitsList(params)),
	getHolder: params => dispatch(getHolder(params)),
});

export default compose(
	withClientId,
	connect(mapStateToProps, mapDispatchToProps),
)(GridCards);



// WEBPACK FOOTER //
// ./src/pages/live-view/components/grid-cards/index.js